export const iconFontAwesomeHumanitarianScaleBalanced = (
	<i className="fa-solid fa-scale-balanced"></i>
);
